import { useMutation } from "@tanstack/react-query";
import ClientsService from "../../../services/ClientsService";
import { useInvalidateTeamQueries } from "./useInvalidateTeamQueries";

export const useTransferClientsMutation = (targetCoachId: number) => {
  const invalidateTeamQueries = useInvalidateTeamQueries();

  return useMutation({
    mutationFn: (clientId: number) =>
      ClientsService.transferClients({
        targetCoachId,
        clientId,
      }),
    onSuccess: async () => {
      invalidateTeamQueries();
    },
  });
};
